class List {
    defaultOptions() {
        return {
            '$container': null,
            'onClickNext': function () {
            },
            'urlDetail': '/competition/athlete/result',
            'urlClubDetail': '/competition/club/result'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.response = null;
        this.data = this.settings.data;
        this.needClear = true;

        this.initialize();
    }


    setNeedClear(value) {
        this.needClear = value;
    }

    initialize() {

    }

    setData(xhr) {
        this.response = xhr;
        this.data = xhr.data;
        this.build();
    }

    build() {

        if (this.needClear) {
            this.$container
                .html('');
            this.$list = $('<ul/>')
                .addClass('athlete-list')
                .appendTo(this.$container);
        } else {
            this.removeNextButton();
        }

        for (var i in this.data) {
            let item = this.data[i];

            let $item = this.buildItem(item);

            this.$list.append($item);
        }

        if (this.response.hasNext) {
            let $next = this.buildNextButton();
            this.$list.append($next);
        }
    }

    buildItem(item) {
        let $item = $('<li/>')
            .addClass('athlete-list-item');

        let $name = $('<div/>')
            .addClass('athlete-name')
            .append(
                $('<i/>')
                    .addClass('icon icon-athlete-name')
            )
            .append(
                $('<span/>')
                    .addClass('label')
                    .append("Athl&egrave;te : ")
            )
            .append(
                $('<div/>')
                    .addClass('value')
                    .append(item.label)
            );

        let urlClub = this.settings.urlClubDetail + '?id=' + item.club.Id;
        let $organisme = $('<div/>')
            .addClass('athlete-organisme')
            .append(
                $('<i/>')
                    .addClass('icon icon-athlete-organisme')
            )
            .append(
                $('<span/>')
                    .addClass('label')
                    .append("Club : ")
            )
            .append(
                $('<div/>')
                    .addClass('value')
                    .append(
                        $('<a/>')
                            .attr('href', urlClub)
                            .append(item.club.label)
                    )
            );

        let btnLabel = 'Voir r&eacute;sultats';

        let $btnDetail = $('<a/>')
            .attr('href', this.settings.urlDetail + "?id=" + item.Id)
            .addClass('btn btn-text text-primary')
            .append(btnLabel);


        let $content = $('<div/>')
            .addClass('athlete')
            .addClass('row')
            .append(
                $('<div/>')
                    .addClass('col-12 col-lg-4 athlete-slot-name')
                    .append(
                        $name
                    )
            )
            .append(
                $('<div/>')
                    .addClass('col-12 col-lg-8')
                    .append(
                        $('<div/>')
                            .addClass('row athlete-slot-list')
                            .append(
                                $('<div/>')
                                    .addClass('athlete-slot-item col-12 col-lg-9')
                                    .append(
                                        $organisme
                                    )
                            )
                            .append(
                                $('<div/>')
                                    .addClass('athlete-slot-item athlete-slot-item-action col-12 col-lg-3')
                                    .append(
                                        $('<div/>')
                                            .addClass('d-flex justify-content-center')
                                            .append(
                                                $btnDetail
                                            )
                                    )
                            )
                    )
            );


        $item.append($content);


        return $item;
    }

    removeNextButton() {
        $('.athlete-list-item-btn', this.$list).remove();
    }

    buildNextButton() {
        var self = this;
        let $item = $('<li/>')
            .addClass('athlete-list-item athlete-list-item-btn');


        let $btnNext = $('<button/>')
            .addClass('btn btn-primary btn-next')
            .attr('data-value', this.response.next)
            .append("Voir plus (" + this.response.remains + ')')
            .on('click', function () {
                let $btn = $(this);
                $btn.attr('disabled', 'disabled');
                $btn.html('')
                    .append(
                        $('<i/>')
                            .addClass('fa fa-spin fa-spinner')
                    )
                self.settings.onClickNext($btn.data('value'))
            });

        $item.append($btnNext);

        return $item;

    }

}

module.exports = List;